/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Dry_NeedlingInputs */

const en_service_type_dry_needling = /** @type {(inputs: Service_Type_Dry_NeedlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dry needling`)
};

const pl_service_type_dry_needling = /** @type {(inputs: Service_Type_Dry_NeedlingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Suche igłowanie`)
};

/**
* | output |
* | --- |
* | "Dry needling" |
*
* @param {Service_Type_Dry_NeedlingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_dry_needling = /** @type {((inputs?: Service_Type_Dry_NeedlingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Dry_NeedlingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_dry_needling(inputs)
	return en_service_type_dry_needling(inputs)
});